var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-taxation-project-form',{staticClass:"pt-taxation-project-form__page",attrs:{"id":_vm.id,"is-edit":_vm.is_edit}})}
var staticRenderFns = []

export { render, staticRenderFns }